"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Asset = _interopRequireDefault(require("./Asset"));

var _Rule = _interopRequireDefault(require("./Rule"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Exemption = function Exemption(asset, rule, value) {
  _classCallCheck(this, Exemption);

  _defineProperty(this, "asset", void 0);

  _defineProperty(this, "rule", void 0);

  _defineProperty(this, "value", void 0);

  this.asset = asset;
  this.rule = rule;
  this.value = value;
};

exports["default"] = Exemption;